import { useMutation } from 'react-query';

import { axios } from 'configurations/axios';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { useSessionStore } from 'session/useSessionStore';

export interface ITraceHeader {
    StartTraceByte: number;
    EndTraceByte: number;
    TraceSize: number;
    buffer: null;
    TraceNumber: number;
    Headers: Record<string, string>;
}

export type GetTracesHeadersParams = {
    minTrace: number;
    maxTrace: number;
    path: string;
    ignoreZeros: boolean;
};

export const useGetTracesHeaders = () => {
    const { metadataHost, jwt } = useSessionStore(state => ({
        metadataHost: state.tenantConfiguration?.endpoints.metadata,
        jwt: state.jwtToken,
    }));

    return useMutation<ITraceHeader[], unknown, GetTracesHeadersParams>(
        async ({ minTrace, maxTrace, path, ignoreZeros }) => {
            const response = await axios.get<IResponseAPI<ITraceHeader[]>>(
                `${metadataHost}/Seismic/SeismicTraces/GetTracesHeaders`,
                {
                    params: { minTrace, maxTrace, path, ignoreZeros },
                    headers: {
                        Authorization: 'Bearer ' + jwt,
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data.Result;
        }
    );
};
